import { useEffect } from 'react';
// import { Helmet } from 'react-helmet-async';

const Seo = ({ title, description, keywords=[] }) => {

  useEffect(()=>{
    document.title = title;
    setMetaTag('name', 'description', description);
    setMetaTag('name', 'keywords', keywords)
  },[title, description, keywords])
  const setMetaTag = (attr, key, content) => {
    if(content){
      let element = document.querySelector(`meta[${attr}="${key}"]`)
      if(!content){
        element = document.createElement('meta');
        element.setAttribute(attr, key);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    }
  }
};
export default Seo;

// const Seo = ({ title, description }) => {
//   // const Seo = ({ title }) => {
//   // const name = "description";
//   // const testD = "what about this?";
//   return (
//     <Helmet>
//       <title>TLN - {title}</title>
//       <meta name="description" content={description} />
//     </Helmet>
//   );
// };
// export default Seo;

// use to measure length
// <title>The Ultimate Designs Company :: Interior Design - Decoration</title>
// <meta name="description" content="Specializing in Custom Woodworking, Wood Furniture, Fireplace Mantels, Cabinet Making, Wainscoting, Moulding, and Interior Painting."/>
// const Seo = ({ title, description, type, name }) => {

// <Helmet>
//       <title>{title}</title>
//       <meta name="description" content={description} />
//       <meta property="og:type" content={type} />
//       <meta property="og:title" content={title} />
//       <meta property="og:description" content={description} />
//       <meta name="twitter:creator" content={name} />
//       <meta name="twitter:card" content={type} />
//       <meta name="twitter:title" content={title} />
//       <meta name="twitter:description" content={description} />
//     </Helmet>